module.exports = __webpack_public_path__ + "img/guihua.ad423897.jpg";